import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { CommonModule } from '@angular/common';
import { EYesNo } from '../../../../../shared/models/types.enum';

@Component({
  selector: 'support-resources',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './support-resources.component.html',
  styleUrl: './support-resources.component.css'
})
export class SupportResourcesComponent implements OnInit, OnChanges {

  @Input() studentInterviewData: any;
  @Output() onSaveSection4 = new EventEmitter<any>();

  yesNo = EYesNo;
  supportResourcesForm: FormGroup = new FormGroup([]);
  questionList = [
    {
      question: "Who in the school do you talk to when you have problems? *",
      formControlName: "problems",
    },
    {
      question: "Who do you talk to outside of school (home, family, friends) when you have problems? *",
      formControlName: "outside_school",
    },
    {
      question: "What else would you like to share about this situation? *",
      formControlName: "other_information",
    }
  ]

  radioQuestions = [
    {
      id: 'doctors_counselors',
      questionText: "Do you see any doctors, counselors, or agency workers? *",
      formControlName: 'doctors_counselors',
      infoFormControlName: 'doctors_counselors_information'
    },
    {
      id: 'teased',
      questionText: "Do you feel like you are being teased, picked on, bullied, or rejected by anymore?",
      formControlName: 'teased',
      infoFormControlName: 'teased_information'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['studentInterviewData'] && this.studentInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      const defaultValue = this.studentInterviewData && this.studentInterviewData[question.formControlName] !== undefined
                           ? this.studentInterviewData[question.formControlName]
                           : this.yesNo.No;

      group[question.formControlName] = new FormControl(
          String(defaultValue),
          Validators.required
      );
      group[question.infoFormControlName] = new FormControl({ value: this.studentInterviewData?.[question.infoFormControlName] || '', disabled: this.studentInterviewData?.[question.infoFormControlName] ? false : true });
    });
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.studentInterviewData?.[question.formControlName] || '', Validators.required);
    });

    this.supportResourcesForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.supportResourcesForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.supportResourcesForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }

  saveSupportResources(): void {
    if (this.supportResourcesForm.valid) {
        this.onSaveSection4.emit(this.supportResourcesForm.value);
    }
  }

}
